import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';
import { IFastFiltersUserSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';
import {
  fetchCianApiSiteV1GetUserDataByRequest,
  TCianApiSiteV1GetUserDataByRequestResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';

interface IUserResolve {
  user: IFastFiltersUserSchema;
}

const DEFAULT_USER_STATE = {
  isAuthenticated: false,
};

export async function getUser(
  httpApi: IHttpApi,
  logger: ILogger,
  cookie?: string,
  subdomain?: string,
): Promise<IUserResolve> {
  try {
    const userDataByRequestDataResponse: TCianApiSiteV1GetUserDataByRequestResponse =
      await fetchCianApiSiteV1GetUserDataByRequest({
        httpApi,
        config: {
          requestConfig: {
            headers: [['cookie', cookie || '']],
          },
          subdomain,
        },
      });

    return {
      user: userDataByRequestDataResponse.response.data.user ?? (DEFAULT_USER_STATE as IFastFiltersUserSchema),
    };
  } catch (err) {
    logger.error(err, {
      message: err.message,
      stack: err.stack,
      comment: 'Ошибка запроса в get-user-data-by-request',
    });

    return {
      user: DEFAULT_USER_STATE as IFastFiltersUserSchema,
    };
  }
}
